/*
 * Title component
 */
import React from 'react';
import Base from './base.jsx';
import {
  castDataType,
  DataType
} from '../common.jsx'
import Setting from "./setting.jsx";

import { CommentButton } from '../comment_thread.jsx';
import PdfAnchor from '../../common/pdf/PdfAnchor.jsx';

export default class Title extends Base {

        constructor(props) {
          super(props);

          this.state = {
            comments: this.props.comments?.[this.props.content?.id]?.data || [],
            commentShow: this.props.comments?.[this.props.content?.id]?.open || false
          };
          this.handleToggleCommentThread = this.handleToggleCommentThread.bind(this);
        }

        handleToggleCommentThread(data) {
          this.setState({comments: data, commentShow: true});
        }

        static get ANSWER_DEPENDENT() {
          return false
        }
  
        static get CATEGORY() {
            return 'other';
        }

        static get TYPE() {
            return 'title';
        }

        static icon(){
            return <i className="fa fa-header"></i>;
        }

        static get TRANSLATED_ATTRIBUTES() {
            return {
                text: 'title_default_text'
            };
        }

        static defaultContent(language) {
            return Object.assign(super.defaultContent(language), {
                text: 'text',
                level: 1,
                guideline: false,
                title_color: '#000000'
            });
        }

        renderView() {
          const [AnchorElement, anchorName] = PdfAnchor();
            return <>
              {
                this.props.content.commenting && this.props.commentSendUrl && 
                <CommentButton 
                  title={this.getText('text')}
                  comments={{[this.props.content.id]: this.state.comments}}
                  handleToggleCommentThread={this.handleToggleCommentThread}
                  boundTo={this.props.content.id}
                  show={this.state.commentShow}
                  setShow={(v) => this.setState({commentShow: v})}
                  commentSendUrl={this.props.commentSendUrl ? this.props.commentSendUrl.replace('__thread__', this.props.content.id) : ''}
                  commentEditUrl={this.props.commentEditUrl ? this.props.commentEditUrl.replace('__thread__', this.props.content.id) : ''}
                  commentDeleteUrl={this.props.commentDeleteUrl ? this.props.commentDeleteUrl.replace('__thread__', this.props.content.id) : ''}
                  commentToggleThreadUrl={this.props.commentToggleThreadUrl ? this.props.commentToggleThreadUrl.replace('__thread__', this.props.content.id) : ''}
                  commentPermissions={this.props.commentPermissions}
                  loggedPersonId={this.props.loggedPersonId}
                /> 
              }
              <AnchorElement />
              {React.createElement('h' + this.props.content.level, {style: {
                  paddingRight: this.props.content.commenting ? 60 : 0,
                  paddingLeft: this.state.commentShow ? 5 : 0,
                  color: this.props.content.title_color,
                  boxShadow: (this.props.content.commenting && this.state.commentShow) ? 'rgba(66, 172, 167, 0.5) 0px 0px 4px 3px' : 'none',
                  borderRadius: '5px'
                }, 
                name: anchorName}, 
                [
                  this.getText('text'),
                ]              
              )}
            </>
        }

        renderPrettyView() {
          const [AnchorElement, anchorName] = PdfAnchor();
           // Doesn't have label and can toggle hide by using guideline
          return (
              !this.props.content.guideline ?
              React.createElement('h' + this.props.content.level, {style: {paddingRight: this.props.content.commenting ? 60 : 0, color: this.props.content.title_color}, name: anchorName}, 
              [
                this.getText('text'),
              ]              
            ) :
            null
          )
        }

        renderSettings() {
            return (
                <div>
                    <Setting.TextField name="text" label={I18n.t('field_text', {scope: 'fe'})} value={this.getText('text')} onChange={this.updateSettings} onKeyPress={this.preventEnterSubmit} />
                    <Setting.Dropdown name="level" label={I18n.t('title_level', {scope: 'fe'})} value={this.props.content.level} onChange={this.updateSettings} options={[1, 2, 3, 4, 5, 6]} />
                    <Setting.Checkbox name="commenting" label={I18n.t('title_comment', {scope: 'fe'})} value={this.props.content.commenting} onChange={this.updateSettings} />
                    <Setting.Checkbox name="guideline" label={I18n.t('guideline', {scope: 'fe'})} value={this.props.content.guideline} onChange={this.updateSettings} />
                    <Setting.ColorPicker name="title_color" label={I18n.t('title_color', {scope: 'fe'})} value={this.props.content.title_color} onChange={this.updateSettings} />
                </div>
            );
        }

        beforeUpdateSettings(content) {
            content.level = castDataType(content.level, DataType.INTEGER);
            content.commenting = castDataType(content.commenting, DataType.BOOLEAN);
            content.guideline = castDataType(content.guideline, DataType.BOOLEAN);
        }
}
